import { Button } from "design-system/atoms/Button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useTranslation } from "react-i18next"

type OptOutDialogProps = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  isPending?: boolean
}

export function OptOutDialog({ open, onClose, onConfirm, isPending }: OptOutDialogProps) {
  const { t } = useTranslation()

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose()
      }}
    >
      <DialogContent>
        <DialogHeader className="flex flex-col gap-6">
          <DialogTitle>{t("customers.profile.optOut.title")}</DialogTitle>
          <DialogDescription>
            <p>{t("customers.profile.optOut.description")}</p>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="pt-4 gap-2">
          <Button type="button" variant="outline" onClick={onClose} disabled={isPending}>
            {t("shared.cancel")}
          </Button>
          <Button type="button" variant="destructive" onClick={onConfirm} disabled={isPending}>
            {t("customers.profile.optOut.confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
